(function () {
    'use stict';

    try {
        // GLOWEB-8783 - check for cookie set on the store page where running AB test, based on result update download IDs
        if (/store-silver-ab=c/.test(document.cookie)) {
            ABTestDownloadIDs.init({"IDSuffix": "-GLOWEB-8783-C", "query": "[data-download-name^=AVAST-ONE-FREE-WIN-PP]"});
            ABTestDownloadIDs.run();
        } else if (/store-silver-ab=1/.test(document.cookie)) {
            ABTestDownloadIDs.init({"IDSuffix": "-GLOWEB-8783-1", "query": "[data-download-name^=AVAST-ONE-FREE-WIN-PP]"});;
            ABTestDownloadIDs.run();
        }

    } catch (error) {
        // singe data layer error tracking
        if (typeof sdl !== 'undefined') {
            console.error(error);
            sdl.push({
                system: {
                    error: {
                        type: error.name,
                        message: error.message,
                    }
                },
                event: 'system.error'
            })
        }
    }
})()